import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const LOGOUT_USER = 'LOGOUT_USER'

//console.log('createBetlimit: '+ ADD_BETLIMITS)

const betlimit_obj = {
    namespaced: true,
    state: {
        betlimit: []
    },
    mutations: {
        LOGOUT_USER (state) {
            state.betlimit = []
        }
    },
    getters: {
        betlimit (state) {
            return state.betlimit
        }
    },
    actions: {
        // API Calls
        async getAllBetLimit ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                //console.log('getAllBetLimit data: ', data)
                const response = await axios.get('betlimit', {params: {round: data.round, lottotype_id: data.lottotype_id, bettype_id: data.bettype_id, number: data.number,}})
                //console.log('getAllBetLimit: ', response)
                //commit(ADD_BETLIMITS, response.data)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getOverLimitNumber ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                //console.log('getOverLimitNumber data: ', data)
                const response = await axios.get('betlimit/overlimit', {params: {round: data.round, lottotype_id: data.lottotype_id, round_date: data.round_date}})
                //console.log('getOverLimitNumber: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async getBetlimit ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('betlimit/' + data)
                //console.log('getBetlimit: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },

    }
}

export default betlimit_obj
